
import { ErrorHandler, Injectable, Injector, InjectionToken, inject } from '@angular/core';

import { AuthService } from './shared/auth/auth.service';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import * as Rollbar from 'rollbar';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';


registerLocaleData(localeIt, 'it-IT');

export function rollbarFactory() {
  const rollbarConfig: Rollbar.Configuration = {
    accessToken: 'e77f87f8a6c04aeeaef565e17fc90649',
      captureUncaught: true,
      captureUnhandledRejections: true,
      environment: 'production',
      payload: {
        environment: 'production',
        client: {
          javascript: {
            source_map_enabled: true, // true by default
            
            // -- Add this into your configuration ---
            code_version: '1.0',
            // ---------------------------------------
            
            // Optionally have Rollbar guess which frames the error was 
            // thrown from when the browser does not provide line 
            // and column numbers.
            guess_uncaught_frames: true
          }
        }
      }
  };

    return rollbarConfig;
}

export const RollbarService = new InjectionToken<Rollbar>('rollbar');

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private injector = inject(Injector);
  private rollbar = inject<Rollbar>(RollbarService);

  

  constructor() { }

  handleError(error): void {
      console.error('Exception handled - ', error);

      const production = environment.production;
      if (production) {
          this.rollbar.error(error.originalError || error);
          const router = this.injector.get(Router);
          const authService = this.injector.get(AuthService);
          authService.logout();
          router.navigate(['/error']);
      } 
  }
}



